/* eslint-disable prettier/prettier */
import { all, call, fork, put, takeLatest } from 'redux-saga/effects';
import Axios from 'assets/remote/axios';
import {
  GET_FEATURES,
  GET_MUKEBS,
  UPDATE_MUKEB,
  CREATE_MUKEB,
  GET_OLD_MUKEB,
} from '../actions';
import {
  features,
  mukebs,
  mukebError,
  mukebSuccess,
  updateActionMukeb,
  adminItems,
  oldMukebs,
  oldMukebSuccess,
  oldMukebError,
} from './actions';

function* errorHandler(error) {
  try {
    if ('response' in error) {
      const keys = Object.keys(error?.response?.data?.errors);
      // eslint-disable-next-line no-restricted-syntax
      for (const item of keys)
        yield put(mukebError(error?.response?.data?.errors[item][0]));
      yield put(mukebError(''));
    } else {
      yield put(mukebError(error.message));
      yield put(mukebError(''));
    }
  } catch (e) {
    yield put(mukebError('خطا انجام فرآیند'));
    yield put(mukebError(''));
  }
}

function* errorHandlerUpdated(error) {
  try {
    if ('response' in error) {
      const keys = Object.keys(error?.response?.data?.errors);
      // eslint-disable-next-line no-restricted-syntax
      for (const item of keys)
        yield put(mukebError(error?.response?.data?.errors[item][0]));
    } else {
      yield put(mukebError(error.message));
    }
  } catch (e) {
    yield put(mukebError('خطا انجام فرآیند'));
  }
}

export function* watchGetMukebs() {
  // eslint-disable-next-line no-use-before-define
  yield takeLatest(GET_MUKEBS, getMukebs);
}
const getMukebsAsync = async (filter) => {
  const r = await Axios.get('/mukebs', { filter });
  return r?.data;
};
function* getMukebs({ payload }) {
  const { filter } = payload;
  try {
    const response = yield call(getMukebsAsync, filter);
    yield put(mukebs(response));
    yield put(mukebSuccess('لیست با موفقیت دریافت شد'));
    yield put(mukebSuccess(''));
  } catch (error) {
    yield call(errorHandler, error);
  }
}

export function* watchGetOldMukeb() {
  yield takeLatest(GET_OLD_MUKEB, getOldMukeb);
}

const getOldMukebAsync = async (mobile) => {
  const res = await Axios.get(`/mukeb/get-old-mukeb/${mobile}`);

  return res.data;
};

function* getOldMukeb({ payload }) {
  const { mobile } = payload;

  try {
    const res = yield call(getOldMukebAsync, mobile);
    yield put(oldMukebs(res));
    yield put(oldMukebSuccess('اطلاعات موکب با موفقیت دریافت شد'));
  } catch (error) {
    yield call(errorHandler, error);
  }
}

export function* watchGetFeatures() {
  // eslint-disable-next-line no-use-before-define
  yield takeLatest(GET_FEATURES, getFeatures);
}
const getFeaturesAsync = async (filter) => {
  const r = await Axios.get('/features', { filter });
  return r?.data;
};
function* getFeatures({ payload }) {
  const { filter } = payload;
  try {
    const response = yield call(getFeaturesAsync, filter);
    yield put(features(response.features));
    yield put(adminItems(response.admin_items));
    yield put(mukebSuccess('لیست با موفقیت دریافت شد'));
    yield put(mukebSuccess(''));
  } catch (error) {
    yield call(errorHandler, error);
  }
}

export function* watchCreateMukeb() {
  // eslint-disable-next-line no-use-before-define
  yield takeLatest(CREATE_MUKEB, createMukeb);
}

const createMukebAsync = async (payload) => {
  const response = await Axios.post('mukebs', payload);
  return response?.data;
};

function* createMukeb({ payload }) {
  try {
    // yield call(delay, 2000)
    // throw "hi";
    yield put(updateActionMukeb('loading'));
    const result = yield call(createMukebAsync, payload);
    // yield call(delay, 1000)
    yield put(updateActionMukeb('success'));
    // yield call(delay, 1000)
    // throw 'error';
    yield call(getMukebs, { payload: {} });
    yield put(mukebSuccess(result.message));
    // yield put(mukebSuccess(''));
  } catch (error) {
    yield call(errorHandlerUpdated, error);
    yield put(updateActionMukeb('error'));
  }
}

export function* watchUpdateMukeb() {
  // eslint-disable-next-line no-use-before-define
  yield takeLatest(UPDATE_MUKEB, updateMukeb);
}

const updateMukebAsync = async ({ payload, id }) => {
  const response = await Axios.patch(`/mukebs/${id}`, payload);
  return response?.data;
};

function* updateMukeb({ payload }) {
  try {
    const result = yield call(updateMukebAsync, { payload });
    yield call(getMukebs, { payload: {} });
    yield put(mukebSuccess(result.message));
    yield put(mukebSuccess(''));
  } catch (error) {
    yield call(errorHandler, error);
  }
}

// const createMukebAsync = async (id, key, value) => {
//     const response = await Axios.put(`/settings/${id}`, { key, value })
//     return response?.data;
// };

export default function* rootSaga() {
  yield all([
    fork(watchGetFeatures),
    fork(watchGetMukebs),
    fork(watchCreateMukeb),
    fork(watchUpdateMukeb),
    fork(watchGetOldMukeb),
  ]);
}
